import { EditModes, Actions } from "../utils/constants";
import { produce } from "immer";
import { authorizationHelper } from "../store/helpers/AuthorizationHelper";
const initialState = {
  contentFocused: false,
  // id -> status/error
  action: { status: {}, error: {} },
  dropIndicator: {
    id: null,
    position: null,
  },
  editMode: { value: EditModes.Disable },
  formulaBoxEditMode: { value: EditModes.Disable },
  isGotoBoxVisible: false,
  isSmartSearchBoxVisible: false,
  cycleToGrid: false,
  error: {
    show: false,
    type: "Error",
    summary: null,
    detail: null,
    buttons: [],
  },
  blueZone: false,
  showFormulaBox: false,
  showCustomSort: false,
};
export default {
  namespaced: true,
  state: () => ({ ...initialState }),
  mutations: {},
  actions: {
    toggleFormulaBox({ state }, data) {
      state.showFormulaBox = data ?? !state.showFormulaBox;
    },
    toggleCustomSort({ state }, data) {
      state.showCustomSort = data ?? !state.showCustomSort;
    },
    setFormulaBoxEditMode({ commit, dispatch, state }, data) {
      state.formulaBoxEditMode = { value: data };
    },
    toggleBlueZone({ state }) {
      state.blueZone = !state.blueZone;
    },
    setError({ commit, state, dispatch }, error) {
      state.error = error;
    },
    async status({ commit, state, rootGetters, dispatch }, data) {
      state.action.status = { ...state.action.status, ...data };
    },

    async error({ state }, data) {
      state.action.error = produce(state.action.error, (error) => {
        Object.assign(error, data); // Merge data into the error
      });
    },
    async setContentFocus({ commit, dispatch, state }, data) {
      state.contentFocused = data;
    },
    setDropIndicator({ commit, dispatch, state }, { id, position }) {
      state.dropIndicator = {
        id,
        position,
      };
    },
    resetDropIndicator({ commit, dispatch, state }) {
      state.dropIndicator = {
        id: null,
        position: null,
      };
    },
    setEditMode({ commit, dispatch, state }, data) {
      state.editMode = { value: data };
    },
    setGotoBox({ commit, dispatch, state }, data) {
      state.isGotoBoxVisible = data;
    },
    setSmartSearchBoxVisibility({ commit, dispatch, state }, data) {
      state.isSmartSearchBoxVisible = data;
    },
    async setSelectedItemId({ state, dispatch, rootState }, value) {
      if (value) {
        const permissionHelper = authorizationHelper(dispatch, rootState);
        const isAuthorized = await permissionHelper.checkProcessPermission(value, Actions.SHARE);
        if (isAuthorized) state.selectedItemId = value;
      } else {
        state.selectedItemId = null;
      }
    },
    async resetState({ state }) {
      Object.assign(state, { ...initialState });
    },
    async setCycleToGrid({ commit, state, dispatch, getters, rootState }, value) {
      state.cycleToGrid = value;
    },
    setOpenedItem({ state }, payload) {
      state.openedItem = payload;
    },
    resetOpenedItem({ state }) {
      state.openedItem = {};
    },
  },
};
